import { observer } from "mobx-react-lite";
import { type CSSProperties, type PropsWithChildren } from "react";
import { useLocation } from "react-router";

import { useAuthContext } from "src/auth/AuthContext";

import { AuthLayout } from "./AuthLayout";
import { UpgradePaywall } from "./UpgradePaywall";

type PageLocation =
  | "payment-success"
  | "upgrade-paywall"
  | "default"
  | "shareable";

export const RootLayout = observer(function RootLayout(
  props: PropsWithChildren,
) {
  const authContext = useAuthContext();
  const location = useLocation();

  function getPageLocation(): PageLocation {
    if (location.pathname === "/payment-success") {
      return "payment-success";
    }

    if (location.pathname.startsWith("/shared")) {
      return "shareable";
    }

    if (authContext.store.isFreeTier && authContext.store.isCoach) {
      return "upgrade-paywall";
    }

    return "default";
  }

  const pageLocation = getPageLocation();

  if (pageLocation === "default" && authContext.store.isAuthenticated) {
    return <AuthLayout>{props.children}</AuthLayout>;
  }

  return (
    <main
      className="w-full h-full"
      style={
        {
          "--sztama-auth-navigation-height": 0,
        } as CSSProperties
      }
    >
      {pageLocation === "upgrade-paywall" ? <UpgradePaywall /> : props.children}
    </main>
  );
});
